const state = {
  streakStartDate: '',
};

const getters = {
  getStartDate: state => state.streakStartDate,
};

const mutations = {
  setStartDate(state, streakStartDate) {
    state.streakStartDate = streakStartDate;
  },
};

const actions = {
  updateStreakStartDate({ commit, rootGetters }, streakStartDate) {
    commit('setStartDate', streakStartDate);
    const params = { data: { streakStartDate } };
    return rootGetters['session/ajax'].post('user_datum', params);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
